import { createUseStyles } from 'react-jss'

import { COLOR, MQ, Z_INDEX } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    [MQ.TABLET_LARGE]: {
      flexDirection: 'row',
      padding: [0, '5%', 75],
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    [MQ.DESKTOP]: {
      padding: [0, '5%', 125],
      maxWidth: 1560,
    },
  },
  columnWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    maxWidth: 650,
    [MQ.TABLET_LARGE]: {
      width: '60%',
      maxWidth: 'unset',
    },
  },
  playerWrapper: {
    position: 'relative',
  },
  video: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0,
    backgroundColor: 'black',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    margin: [30, 0],
    [MQ.TABLET_LARGE]: {
      width: '82%',
      margin: [30, 0, 0],
    },
    [MQ.DESKTOP]: {
      margin: [60, 0, 0],
    },
  },
  title: {
    padding: [10, 0],
    [MQ.DESKTOP]: {
      padding: [22, 0],
    },
  },
  category: {
    textTransform: 'uppercase',
  },
  upNextWrapper: {
    background: COLOR.YELLOW,
    width: '90%',
    padding: [20],
    margin: [0, 0, 75],
    maxWidth: 650,
    [MQ.TABLET_LARGE]: {
      width: '38%',
      maxWidth: 'unset',
    },
    [MQ.DESKTOP]: {
      padding: [30],
    },
  },
  upNextCategory: {
    textTransform: 'uppercase',
  },
  upNextTitle: {
    margin: [14, 0],
    [MQ.DESKTOP]: {},
  },
  upNext: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textDecoration: 'none',
    color: COLOR.DARK_GREEN,
    padding: [20, 0],
    [MQ.DESKTOP]: {
      padding: [27, 0],
    },
  },
  upNextImage: {
    width: '48%',
    height: '100%',
  },
  upNextTextBlock: {
    width: '48%',
  },

  autoplayScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: Z_INDEX.CONTENT,
    background: COLOR.BLACK,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    color: COLOR.WHITE,
    overflow: 'hidden',
  },
  countdown: {
    width: '40%',
    textAlign: 'left',
    margin: [0, 0, 5],
    [MQ.TABLET]: {
      margin: [15, 0],
    },
  },
  autoplay: {
    width: '100%',
    textAlign: 'center',
    '& span': {
      padding: [0, 10],
    },
  },
  autoplayThumbnail: {
    marginBottom: 7,
    width: '40%',
    margin: 'auto',
  },
  buttons: {
    display: 'flex',
    marginTop: 10,
  },
  button: {
    outline: 'none',
    border: 'none',
    backgroundColor: 'rgba(30,30,30,.9)',
    color: COLOR.WHITE,
    padding: [5, 25],
    borderRadius: 8,
    textDecoration: 'none',
    margin: [0, 10],
    cursor: 'pointer',
    [MQ.TABLET_LARGE]: {
      padding: [10, 30],
    },
    '&:hover': {
      backgroundColor: COLOR.YELLOW,
    },
  },
})
